export enum DipRegistratioOneTrustUrls {
    TEST = 'https://cdn.cookielaw.org/consent/58bd9410-3537-402a-a626-f44d31eb8404-test/otSDKStub.js',
    PROD = 'https://cdn.cookielaw.org/consent/58bd9410-3537-402a-a626-f44d31eb8404/otSDKStub.js'
}
